import styles from './Counter.module.css'

interface CounterProps {
  label: string
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
}

export function Counter({ label, value, onChange, min = 0, max = 99 }: CounterProps) {
  return (
    <div className={styles.wrapper}>
      <span className={styles.label}>{label}</span>
      <div className={styles.controls}>
        <button
          type="button"
          className={styles.btn}
          onClick={() => onChange(Math.max(min, value - 1))}
          disabled={value <= min}
          aria-label={`Reducir ${label}`}
        >
          −
        </button>
        <span className={styles.value} aria-live="polite">{value}</span>
        <button
          type="button"
          className={styles.btn}
          onClick={() => onChange(Math.min(max, value + 1))}
          disabled={value >= max}
          aria-label={`Aumentar ${label}`}
        >
          +
        </button>
      </div>
    </div>
  )
}
